import { createSlice } from "@reduxjs/toolkit";
import Utils from "../utils/utils";

export const reducer = createSlice({
  name: "appReducer",
  initialState: {
    user: null,
    isLogged: false,
    openMenu: false,
    loader: false,
    toast: [],
  },

  reducers: {
    setUser: (state, { payload }) => {
      state.isLogged = true;
      state.user = payload;
    },
    setLogged: (state) => {
      state.isLogged = true;
    },
    toggleMenu: (state) => {
      state.openMenu = !state.openMenu;
    },
    setToast: (state, { payload }) => {
      state.toast = [...state.toast, { ...payload, id: Utils.generateId() }]
    },
    handleLoader: (state, { payload }) => {
      state.loader = payload
    },
    removeToast: (state, { payload }) => {
      let _toasts = state.toast;
      if (payload) {
        let _index = _toasts.findIndex(x => x.id === payload)
        _toasts.splice(_index, 1);
      } else {
        state.toast = _toasts.slice(1);
      }
    },
    logoutUser: (state) => {
      state.user = null;
      state.isLogged = false;
    },
  },
});

export const {
  setLogged,
  setToast,
  setUser,
  logoutUser,
  handleLoader,
  removeToast,
  toggleMenu,
} = reducer.actions;

export default reducer.reducer;